import { Field, Link, LinkField, RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import ForumIcon from 'public/icons/Forum.svg';

import styles from './ForumSignpost.module.css';

type ForumSignpostProps = ComponentProps & {
	fields: {
		Heading: Field<string>;
		Text: Field<string>;
		Forum: LinkField;
	};
};

export default function ForumSignpost(props: ForumSignpostProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && !props.fields) {
		return <></>;
	}

	if (isEditing && !props.fields) {
		return <EditorHelp text={'Click here to select a Forum to signpost or you can leave bank'} />;
	}

	return (
		<section className={`${styles.signPost} pinkLightest shadow`}>
			<div className={styles.signPostHeader}>
				<Text tag="h4" className={styles.heading} field={props.fields?.Heading} />

				<span className={styles.icon}>
					<ForumIcon className={styles.svg} />
				</span>
			</div>

			<RichText className={styles.bodyText} field={props.fields?.Text} />

			<Link field={props.fields?.Forum}></Link>
		</section>
	);
}
